// src/api/modulesApi.js
import axios from "axios";

export const updateMenus = async (id, updatedData) => {
  try {
    const response = await axios.put(`http://localhost:8080/webnet-hms/api/menus/update/${id}`, updatedData);
    console.log(response.data);
    alert("Menu Updated");
  } catch (error) {
    window.alert("Error updating module:", error);
    throw error;
  }
};
